<section class="section-white" *ngIf="otherFeaturesData">
  <div class="section-container">
    <h2 class="section-heading mar-b-32">
      {{ otherFeaturesData?.title }}
    </h2>
    <div class="section-description mar-b-48 align-c">
      <div
        class="wid-75"
        [innerHtml]="otherFeaturesData?.content | toHtml"
      ></div>
    </div>
    <div class="section-mediakit-container">
      <div
        class="grey-100 section-mediakit"
        *ngFor="let block of otherFeaturesData?.component1"
      >
        <figure class="display-c">
          <img
            src="{{ block?.fields?.image?.[0]?.fields?.file?.url }}"
            class="ico-64"
            alt="block?.fields?.image?.[0]?.fields?.title"
          />
        </figure>
        <div class="mediakit">
          <h5 class="efficient-payment-heading">
            {{ block?.fields?.title }}
          </h5>
          <div
            class="efficient-payment-description"
            [innerHtml]="block?.fields?.content | toHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
